/* add_instructions.icon.svg.js */

module.exports = {
    icon: `<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <g id="Artboard1" transform="matrix(0.909995,0,0,0.996293,-1.81999,0)">
        <rect x="2" y="0" width="22" height="20" style="fill:none;"/>
        <g transform="matrix(1,0,0,1,2.901174,0)">
            <g transform="matrix(1.098907,0,0,1.003721,-2.37377,-0.460356)">
                <path class="foreground-gl" d="M13.74,5.82L17.74,5.82L13.36,1.25L13.36,5.44C13.36,5.648 13.532,5.82 13.74,5.82Z" style="fill-rule:nonzero;"/>
            </g>
            <g transform="matrix(1.098907,0,0,1.003721,-1.813327,-0.513974)">
                <path class="foreground-gl" d="M3.35,18.87L3.36,2.09C3.36,1.267 4.037,0.59 4.86,0.59L11.48,0.59L11.48,5.44C11.48,6.682 12.498,7.705 13.74,7.71L18.33,7.71L18.33,18.87C18.33,19.687 17.657,20.36 16.84,20.36L4.84,20.36C4.023,20.36 3.35,19.687 3.35,18.87ZM9.49,5L6.49,5L6.49,7L9.49,7L9.49,5ZM15.49,10L6.49,10L6.49,12L15.49,12L15.49,10ZM15.49,15L6.49,15L6.49,17L15.49,17L15.49,15Z"/>
            </g>
        </g>
    </g>
</svg>`,
};
